import { render } from "./AuditLog.vue?vue&type=template&id=27862e80&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"

import "./AuditLog.vue?vue&type=style&index=0&id=27862e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27862e80"]])

export default __exports__